var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsDown = function SvgThumbsDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21.252 2.5v13.75m6.25-4V6.5c0-1.4 0-2.1-.272-2.635a2.5 2.5 0 0 0-1.093-1.093c-.535-.272-1.235-.272-2.635-.272H10.15c-1.827 0-2.74 0-3.478.334a3.75 3.75 0 0 0-1.593 1.367c-.443.678-.582 1.581-.86 3.387l-.653 4.25c-.367 2.381-.55 3.572-.196 4.498a3.75 3.75 0 0 0 1.65 1.924c.862.49 2.066.49 4.476.49h1.006c.7 0 1.05 0 1.318.136.235.12.426.311.546.547.136.267.136.617.136 1.317v3.668a3.08 3.08 0 0 0 3.083 3.082c.406 0 .773-.24.938-.61l4.201-9.452c.192-.43.287-.645.438-.803a1.25 1.25 0 0 1 .479-.311c.205-.074.44-.074.911-.074h.95c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 0 0 1.093-1.092c.272-.535.272-1.235.272-2.635"
  })));
};
export default SvgThumbsDown;